import MultiSelect from "components/common/MultiSelect";
import React, { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import { handleClaimDashboardFilter } from "../config/claimDashboardSlice";

const ClaimDashboardFilter = ({ watch, setValue, control, onFilter }) => {
    const dispatch = useDispatch();
    const { claimDashboardFilters } = useSelector((state) => state.claimDashboard);
    const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

    const handleBranches = (selected) => {
        let value = [];
        if (selected && selected.length > 0) {
            value = selected.map((item) => ({
                branch_name: item?.label,
                branch_id: item?.value,
                cchi: item?.cchi,
            }));
        }
        setValue("branches", value);
        // Don't update Redux state automatically - only when Filter button is clicked
    };

    const handleDateRange = (dates) => {
        const [start, end] = dates;
        let frm_mnth = "";
        let to_mnth = "";

        if (start) {
            // Use local date methods to avoid timezone issues
            const year = start.getFullYear();
            const month = String(start.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based
            frm_mnth = `${year}-${month}`;
        }
        if (end) {
            // Use local date methods to avoid timezone issues
            const year = end.getFullYear();
            const month = String(end.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based
            to_mnth = `${year}-${month}`;
        }

        setValue("dateRange", [frm_mnth, to_mnth]);
        setValue("frm_mnth", frm_mnth);
        setValue("to_mnth", to_mnth);
        // Don't update Redux state automatically - only when Filter button is clicked
    };

    useEffect(() => {
        setValue("branches", claimDashboardFilters?.branches || []);

        // Initialize dateRange with proper Date objects for the range picker
        const dateRange = [
            getDateFromMonth(claimDashboardFilters?.frm_mnth),
            getDateFromMonth(claimDashboardFilters?.to_mnth)
        ];
        setValue("dateRange", dateRange);

        setValue("frm_mnth", claimDashboardFilters?.frm_mnth || "");
        setValue("to_mnth", claimDashboardFilters?.to_mnth || "");
    }, [claimDashboardFilters, setValue]);

    // Convert month strings to Date objects for DatePicker
    const getDateFromMonth = (monthStr) => {
        if (!monthStr) return null;
        return new Date(monthStr + "-01");
    };


    return (
        <Form onSubmit={onFilter}>
            <Row alignItems="center" className="mb-3">
                <Col xs={12} sm={6} md={3} xl={2}>
                    <label className="form-label">Branches</label>
                    <Controller
                        name="branches"
                        control={control}
                        rules={{
                            required: false,
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <MultiSelect
                                {...field}
                                isMulti
                                isClearable
                                options={allBranches.map((b) => ({
                                    value: b.branch_id,
                                    label: b.branch_name,
                                    cchi: b.branch_cchino,
                                }))}
                                value={watch("branches")?.map((item) => ({
                                    value: item?.branch_id,
                                    label: item?.branch_name,
                                    cchi: item?.cchi,
                                }))}
                                onChange={(val) => handleBranches(val)}
                                placeholder="Choose branches..."
                                className={error ? "is-invalid" : ""}
                            />
                        )}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} xl={2}>
                    <BootDatePicker
                        name="dateRange"
                        label="Month Range"
                        control={control}
                        onChange={handleDateRange}
                        selectsRange
                        showMonthYearPicker
                        showDashboardPredefinedRanges
                        showTodayButton={false}
                        popperProps={{ strategy: "fixed" }}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} xl={2} className="mt-4">
                    <Button type="submit" size="sm">
                        Filter
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default ClaimDashboardFilter;
